import { memo, useCallback } from 'react';
import { ListRenderItem } from 'react-native';
import usePromos from '../hooks/usePromos';
import {
  Box,
  List,
  Styles,
  ViewStyle,
  useBreakpointProp,
  VerticalListSeparator,
} from '@betty/moonlight';
import PromoListItem from './PromoListItem/PromoListItem';
import PromosSkeleton from './PromosSkeleton';
import { PromosListEmpty } from './PromosEmptyStates';
import { Promotion } from '../state/promos/promos.types';
import useBreakpoint from '@betty/moonlight/lib/hooks/useBreakpoint';
import { Breakpoint } from '@betty/moonlight/lib/hooks/useBreakpoint/index.types';

function Promos() {
  const { promos, promosDataState } = usePromos();
  const breakpoint = useBreakpoint();
  const numColumns = useBreakpointProp({
    mobile: undefined,
    tablet: 2,
    desktop: 3,
  });
  const columnWrapperStyle: Styles<ViewStyle> | undefined =
    breakpoint === Breakpoint.MOBILE
      ? undefined
      : {
          gap: 'space-400',
          justifyContent: 'flex-start',
        };

  const renderItem = useCallback<ListRenderItem<Promotion>>(({ item }) => {
    return (
      <PromoListItem
        flex={1}
        maxWidth={{ mobile: undefined, tablet: '49%', desktop: '32%' }}
        promo={item}
      />
    );
  }, []);

  return (
    <Box flex={1}>
      <List
        data={promos}
        key={numColumns}
        numColumns={numColumns}
        contentContainerStyle={{
          paddingBottom: 'safe-area-inset-bottom',
          paddingTop: 'space-400',
          paddingHorizontal: 'space-400',
          maxWidth: {
            mobile: undefined,
            tablet: undefined,
            desktop: 'max-page-width',
          },
          marginHorizontal: {
            mobile: undefined,
            tablet: undefined,
            desktop: 'auto',
          },
        }}
        columnWrapperStyle={columnWrapperStyle}
        showsHorizontalScrollIndicator={false}
        renderItem={renderItem}
        ListEmptyComponent={
          promosDataState === 'fulfilled' ? PromosListEmpty : PromosSkeleton
        }
        ItemSeparatorComponent={VerticalListSeparator}
      />
    </Box>
  );
}

export default memo(Promos);
